import { Component } from '@angular/core';
import { StepIds } from '../../../models/property-step/property-step-model';
import { DraftFacade, RouterFacade } from '@classifieds-sell/state';
import { PropertyPageBase } from '../../property-page-base';

@Component({
    selector: 'property-information-page',
    templateUrl: './property-information-page.component.html',
    styleUrls: ['./property-information-page.component.scss'],
    standalone: false
})
export class PropertyInformationPageComponent extends PropertyPageBase {
    constructor(draftFacade: DraftFacade, routerFacade: RouterFacade) {
        super(StepIds.propertyInformation, draftFacade, routerFacade);
    }
}
